import { canAccessAdminApp } from '@wapharma/shared';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Outer admin-app entry gate: staff email + at least one role or pack.
 * Does not toast — AdminShell owns the entry-denial copy and logout.
 * Inner job/pack routes keep RequireRoles / RequirePacks (« Accès refusé. »).
 */
export function RequireStaff() {
  const { user } = useAuth();

  if (!user) return null;
  if (!canAccessAdminApp({ email: user.email, roles: user.roles, packs: user.packs })) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
